import React, { useState } from "react";
import GenericStepper from "../../ui-components/Stepper/GenericStepper";


const StepperPlayground: React.FC<{ theme: "light" | "dark" }> = ({ theme }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;
  const steps = [
    { title: "Details" },
    { title: "Configuration" },
    { title: "Service Overview" },
    { title: "Order Overview" },
    { title: "Confirmation" },
  ]

  // Step navigation handlers
  const handleNext = () => {
    if (currentStep < totalSteps) setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  return (
    <section className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Stepper Playground</h2>

      <GenericStepper
        steps={steps}
        theme={theme}
        orientation="horizontal"
      />

      <div className="flex justify-between mt-6">
        <button
          className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 disabled:bg-gray-200"
          onClick={handleBack}
          disabled={currentStep === 1}
        >
          Back
        </button>
        <button
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
          onClick={handleNext}
          disabled={currentStep === steps.length}
        >
          Next
        </button>
      </div>
    </section>
  );
};

export default StepperPlayground;